<template lang="pug">
.row.mt-4(v-if="loaded")
  .col-12
    h3 Позиции табака
      button.add_one(@click="createItem")
        i.fal.fa-plus-circle(style="margin-right: 5px")
        | Создать позицию
  .col.white_block
    .items_table
      vue-good-table(
        :columns="items_columns",
        :rows="items",
        :search-options="{ enabled: true, skipDiacritics: true, placeholder: 'Поиск по товарам' }",
        :pagination-options="{ enabled: true, perPage: 50, nextLabel: 'Дальше', prevLabel: 'Назад', ofLabel: 'из', pageLabel: 'страница', allLabel: 'Всё', rowsPerPageLabel: 'Строк на странице' }",
        styleClass="datatable vgt-table condensed",
        @on-row-click="editItem",
        :sort-options="{ enabled: true, initialSortBy: { field: 'amount', type: 'asc' } }",
        :row-style-class="TabaccoRowStyleClassFn",
        style="overflow: visible"
      )
        .text-center(slot="emptystate") 
          div(style="padding: 20px; color: gray", @click="createItem") Добавьте первую позицию табака
        template(slot="table-row", slot-scope="props")
          | {{ props.formattedRow[props.column.field] }}
          .actions(v-if="props.column.field == 'after'")
            button.rowAction(
              title="Добавить или убрать позицию из закупок",
              @click.stop.prevent="addToCartList(props.row)",
              :disabled="!props.row.supplier_id",
              :class="{ active: cartList.find((item) => item.id == props.row.id) }"
            )
              i.fas.fa-shopping-cart
            quantity.quantity_holder(
              v-if="props.row.supplier_id && cartList.find((item) => item.id == props.row.id)",
              type="popup",
              :quantity="cartList.find((item) => item.id == props.row.id).amount",
              @Changed="cartList.find((item) => item.id == props.row.id).amount = $event; if ($event == 0) { cartList = cartList.filter((item) => item.id != props.row.id); }"
            )

    //- modal
    modal.item_editor(name="item_editor", height="auto", :adaptive="true") 
      .close(@click="$modal.hide('item_editor')")
        i.fal.fa-times
      .container
        .row(v-if="item_editor.loading")
          .col
            .loader_holder(
              :style="{ margin: '0 auto', width: 200, display: 'block' }"
            )
            object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
        .row(v-if="!item_editor.loading")
          .col
            h2 {{ item_editor.title }}
            .content
              .inputModule
                input-module(
                  type="text",
                  placeholder="Название табака",
                  title="Название",
                  v-model="item_editor.item.name",
                  @change="auto_sug"
                ) 
                .sugs(v-if="sugs.length != 0")
                  .sug(v-for="s of sugs", @click="select_auto_sug(s.id)") {{ s.name }}
                    b {{ s.netto }} г.
              .inputModule(v-if="item_editor.type == 'update'")
                .leftover_input
                  div(
                    style="cursor: default; font-weight: 300; margin-bottom: 2px"
                  ) Остаток товара в единицах
                  div
                    span(style="font-size: 16pt") {{ item_editor.item.amount }} ед.
                    button.add_one(@click="itemTransactionOpen('plus')")
                      i.fal.fa-plus-circle(style="margin-right: 5px")
                      | Оформить пополнение
                    button.add_one(@click="itemTransactionOpen('minus')")
                      i.fal.fa-minus-circle(style="margin-right: 5px")
                      | Оформить списание
              .inputModule(v-if="item_editor.type == 'create'")
                input-module(
                  type="number-change-show",
                  placeholder="0",
                  ref="item_editor_amount",
                  title="Остаток товара в единицах",
                  measure="ед.",
                  v-model="item_editor.item.amount"
                ) 

              .inputModule
                input-module(
                  type="number",
                  placeholder="100",
                  title="Вес единицы",
                  v-model="item_editor.item.netto"
                ) 
              //- TODO доделать
              .inputModule
                input-module(
                  type="select",
                  title="Поставщик",
                  v-model="item_editor.item.supplier_id",
                  :values="[{ id: null, name: '—' }, ...suppliers]",
                  :plusButton="true",
                  :plusButtonPopup="plusButtonPopup",
                  @plusButtonSave="addSupplier",
                  valueKey="id",
                  valueName="name"
                )
              .inputModule
                input-module(
                  type="number",
                  placeholder="990.00",
                  step=".01",
                  title="Цена за единицу",
                  v-model="item_editor.item.price"
                ) 
              .inputModule
                input-module(
                  type="tags",
                  title="Словарь для улучшения поиска",
                  v-model="item_editor.item.dictionary"
                ) 
              .row(v-if="!item_editor.loading")
                .col.buttons
                  button.styled.removeItem.float-left(
                    @click="RemoveItem",
                    v-if="item_editor.type == 'update'"
                  )
                    i.fas.fa-trash
                  button.styled.createLink(
                    @click="CreateUpdate",
                    :disabled="item_editor.item.name.replace(/\s/g, '') == '' || item_editor.item.netto == ''"
                  ) {{ item_editor.actionTitle }}

  modal.item_transaction(
    name="item_transaction",
    height="auto",
    :adaptive="true"
  )
    .close(@click="$modal.hide('item_transaction')")
      i.fal.fa-times
    .container
      .row
        .col
          h2 {{ item_transaction.name }}
          .content
            .inputModule
              input-module(
                type="number",
                title="Количество",
                v-model="item_transaction.amount"
              ) 
            .inputModule
              input-module(
                type="number",
                title="Стоимость",
                v-model="item_transaction.item_price"
              ) 
            .buttons
              button.styled.createLink(
                @click="itemTransactionCreate",
                :disabled="item_transaction.loading"
              ) {{ item_transaction.create_button_name }}
  cart(
    :cartList="cartList",
    @removeItem="removeCartItem",
    @addItem="addCartItem",
    @emptyCartList="emptyCartList",
    :warehouse="warehouse",
    :suppliers="suppliers"
  )
</template>

<script>
import moment from "moment";
import swal from "sweetalert2";
import apiDriver from "../../../apiDriver";
import quantity from "./_cart_quantity.vue";

let copyObject = require("../copyObject").default;

import cart from "./cart";

export default {
  props: [
    "items",
    "loaded",
    "warehouse",
    "miniSearch",
    "all_tobaccos",
    "suppliers",
  ],
  components: {
    cart,
    quantity,
  },
  data() {
    return {
      sugs: [],
      items_columns: [
        {
          label: "Название",
          field: "name",
          type: "text",
        },
        {
          label: "Вес",
          field: "netto",
          type: "number",
        },
        {
          label: "Количество",
          field: "amount",
          type: "number",
        },
        {
          label: "Цена за ед.",
          field: "price",
          type: "number",
        },
        {
          label: "",
          field: "after",
          sortable: false,
        },
      ],
      item_editor: {
        title: "",
        actionTitle: "",
        loading: false,
        type: "",
        item: {
          id: false,
          name: "",
          amount: "",
          price: "",
          netto: "",
          dictionary: [],
          supplier_id: -1,
          store_id: -1,
          removed: 0,
        },
      },

      item_transaction: {
        name: "",
        amount: 0,
        type: "",
        item_id: -1,
        item_price: 0,
        loading: false,
      },

      plusButtonPopup: {
        title: "Добавить поставщика",
        inputs: [
          {
            key: "name",
            type: "text",
            placeholder: "Название поставщика",
            title: "Название",
          },
          {
            type: "phone",
            title: "Телефон",
            key: "phone",
          },
          {
            type: "text",
            title: "Email",
            key: "email",
          },
        ],
      },

      cartList: [],
    };
  },
  methods: {
    addSupplier(data) {
      console.log("items addSupplier", data);
      this.$emit("addSupplier", data);
    },
    emptyCartList() {
      this.cartList = [];
    },
    addCartItem(item_id, amount = 1) {
      console.log("addCartItem", item_id, amount);
      let found_item = this.items.find((x) => x.id == item_id);
      if (!found_item) return;
      let found_cart_item = this.cartList.find((x) => x.item_id == item_id);
      if (found_cart_item) {
        found_cart_item.amount += amount;
      } else {
        this.cartList.push({
          supplier_id: found_item.supplier_id,
          name: found_item.name,
          amount: amount,
          id: found_item.id,
          netto: found_item.netto,
          current_amount: found_item.amount,
        });
      }
    },
    removeCartItem(item) {
      this.cartList = this.cartList.filter((i) => i.id != item.id);
    },
    addToCartList(row) {
      console.log("addToCartList:", row);
      let foundInCartList = this.cartList.find((item) => item.id == row.id);
      if (!foundInCartList) {
        this.cartList.push({
          supplier_id: row.supplier_id,
          name: row.name,
          amount: 1,
          id: row.id,
          netto: row.netto,
          current_amount: row.amount,
        });
      } else {
        foundInCartList.amount++;
      }
    },
    clearItemEditor() {
      copyObject(this.item_editor.item, {
        name: "",
        amount: "",
        price: "",
        netto: "",
        supplier_id: -1,
        removed: 0,
        store_id: parseInt(this.$route.params.id),
        id: false,
        dictionary: [],
      });
    },
    async CreateUpdate() {
      this.sugs = [];
      if (this.item_editor.item.name.replace(/\s/g, "") == "") return;
      if (this.item_editor.item.netto == "") return;
      if (this.item_editor.item.amount == "") this.item_editor.item.amount = 0;
      if (this.item_editor.item.price == "") this.item_editor.item.price = 0;
      this.item_editor.loading = true;
      let data = this.item_editor.item;
      let action = this.item_editor.item.id ? "update" : "create";
      if (action == "update") {
        this.$modal.hide("item_editor");
        (data = JSON.parse(JSON.stringify(data))), delete data.amount;
      }
      let cu = await apiDriver.services.api.post(
        "inventory",
        "item/" + action,
        data
      );
      this.item_editor.loading = false;
      if (!cu) {
        this.$toast.error(
          `Произошла ошибка при ${
            this.item_editor.item.id ? "обновлении" : "создании"
          }.`
        );
        if (action == "update") this.$modal.show("item_editor");
        return;
      }
      this.$toast.success(
        `Товар успешно ${this.item_editor.item.id ? "обновлен" : "создан"}!`
      );
      if (action == "create") {
        // this.items.push(cu.data.item);
        this.$emit("Changed", {
          type: "create",
          new_data: cu.data.item,
        });
      } else {
        // let o = this.items.find((x) => x.id == this.item_editor.item.id);
        // copyObject(o, cu.data.item);
        this.$emit("Changed", {
          type: "update",
          item_id: this.item_editor.item.id,
          new_data: cu.data.item,
        });
      }
      this.$modal.hide("item_editor");
      // this.loadWarehouseTransactions();
    },
    async RemoveItem() {
      this.sugs = [];
      let item_id = this.item_editor.item.id;
      let action = await apiDriver.services.api.post(
        "inventory",
        "item/remove",
        { id: item_id }
      );
      if (!action) {
        this.$toast.error("Ошибка удаления позиции...");
        return;
      }
      this.$toast.success(`Позиция удалена!`);
      this.$modal.hide("item_editor");
      this.$emit("Changed", {
        type: "remove",
        item_id,
      });
    },
    async createItem() {
      this.sugs = [];
      this.$modal.show("item_editor");
      this.item_editor.title = "Новая позиция";
      this.item_editor.actionTitle = "Добавить новый табак";
      this.item_editor.type = "create";
      this.clearItemEditor();
    },
    async editItem(data) {
      this.sugs = [];
      this.$modal.show("item_editor");
      this.item_editor.title = "Редактирование табака";
      this.item_editor.actionTitle = "Сохранить";
      this.item_editor.type = "update";
      this.clearItemEditor();
      copyObject(this.item_editor.item, data.row);
    },

    TabaccoRowStyleClassFn(row) {
      if (row.amount < this.warehouse.minimal_item_amount && row.amount <= 0)
        return "red";
      if (row.amount < this.warehouse.minimal_item_amount && row.amount > 0)
        return "orange";
      return "";
    },

    auto_sug() {
      let t = this.item_editor.item.name;
      if (t.replace(/\s/g, "") == "") return (this.sugs = []);
      let x = this.miniSearch.search(t, { fuzzy: 0.2, prefix: true });
      this.sugs = x; //.slice(0,5);
    },

    select_auto_sug(id) {
      let t = this.all_tobaccos.find((x) => id == x.id);
      console.log("select_auto_sug", id, t);
      copyObject(this.item_editor.item, t, ["amount", "id"]);
      this.sugs = [];
      this.$refs.item_editor_amount.focus();
    },

    itemTransactionOpen(type) {
      this.item_transaction.amount = 0;
      this.item_transaction.item_id = this.item_editor.item.id;
      this.item_transaction.type = type;
      this.item_transaction.item_price = this.item_editor.item.price;
      if (type == "plus") {
        this.item_transaction.name = "Поступление товара";
        this.item_transaction.create_button_name = "Оформить поступление";
      } else {
        this.item_transaction.name = "Списание товара";
        this.item_transaction.create_button_name = "Оформить списание";
      }
      this.$modal.show("item_transaction");
    },
    async itemTransactionCreate() {
      this.item_transaction.loading = true;
      let item_id = this.item_transaction.item_id;
      let type = this.item_transaction.type;
      let amount = this.item_transaction.amount;
      let price = this.item_transaction.item_price;
      if (type == "minus") amount = -1 * amount;
      let update = await apiDriver.services.api.post(
        "inventory",
        "item/transaction",
        { item_id, amount, price }
      );
      this.item_transaction.loading = false;
      if (!update) {
        return this.$toast.error(`Ошибка оформления транзакции`);
      }
      this.$emit("itemTransactionCreated", {
        item_id,
        amount: update.data.updated.amount,
      });
      this.item_editor.item.amount = update.data.updated.amount;
      this.$toast.success(`Транзакция оформлена!`);
      this.$modal.hide("item_transaction");
    },
  },
};
</script>


<style lang="scss" scoped>
.leftover_input {
  padding-left: 15px;
  padding-bottom: 5px;
  margin-left: 10px;
  width: 100%;
  position: relative;
  border-left: 4px solid #ede7f6;

  &:hover {
    border-color: #673ab7;
  }
}

.actions {
  text-align: right;
  position: relative;

  .quantity_holder {
    display: none;
  }

  &:hover {
    .quantity_holder {
      display: block;
    }
  }

  .rowAction {
    border: unset;
    background: unset;
    color: #838383;
    cursor: pointer;
    outline: none;

    &:hover {
      color: rgb(37, 37, 37);
    }
    &.active {
      color: #4caf50;
      // &:hover {
      //   color: #f44336;
      // }
    }
    &:active {
      color: #1b701e;
    }
    &:disabled {
      cursor: default;
      color: #f1f1f1;
    }
  }
}

.sugs {
  max-height: 170px;
  background: #fff;
  overflow: hidden;
  overflow-y: scroll;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 2;
  border-radius: 4px;
  width: calc(100% - 55px);
  left: 40px;
  margin-top: -6px;
  border: 1px solid #eee;

  .sug {
    cursor: pointer;
    padding: 5px 10px;
    b {
      float: right;
    }

    &:hover {
      background: #eee;
    }
  }
}

.add_one {
  cursor: pointer;
  font-size: 12px;
  position: relative;
  top: -3px;
  padding: 0px 10px;
  opacity: 0.6;
  border: 1px solid black;
  border-radius: 20px;
  height: 27px;
  display: inline-block;
  line-height: normal;
  margin-left: 15px;
  outline: none;

  &:hover {
    opacity: 1;
  }
}
</style>

<style lang="scss">
.items_table .vgt-responsive {
  overflow: visible !important;
}
</style>

<style lang="scss" scoped>
@media (prefers-color-scheme: dark) {
  .leftover_input {
    border-color: #383838;
  }

  .actions {
    .rowAction {
      color: #3c3c3c;

      &:hover {
        color: rgb(200, 200, 200);
      }
      &.active {
        color: #4caf50;
        // &:hover {
        //   color: #f44336;
        // }
      }
      &:active {
        color: #19741c;
      }
      &:disabled {
        color: #222222;
      }
    }
  }

  .add_one {
    opacity: 0.9;
  }

  .sugs {
    background-color: #3c3c3c;
    .sug {
      &:hover {
        background-color: #202020;
      }
    }
  }
}
</style>